module.exports = __webpack_public_path__ + "img/approve.c505ea33.png";